/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountRepresentation
 */
export interface AccountRepresentation {
    /**
     * 
     * @type {string}
     * @memberof AccountRepresentation
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof AccountRepresentation
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof AccountRepresentation
     */
    subnumber?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AccountRepresentation
     */
    planType?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountRepresentation
     */
    dataProviderKey: string;
}

/**
 * Check if a given object implements the AccountRepresentation interface.
 */
export function instanceOfAccountRepresentation(value: object): value is AccountRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('dataProviderKey' in value) || value['dataProviderKey'] === undefined) return false;
    return true;
}

export function AccountRepresentationFromJSON(json: any): AccountRepresentation {
    return AccountRepresentationFromJSONTyped(json, false);
}

export function AccountRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'number': json['number'],
        'subnumber': json['subnumber'] == null ? undefined : json['subnumber'],
        'name': json['name'],
        'planType': json['planType'] == null ? undefined : json['planType'],
        'dataProviderKey': json['dataProviderKey'],
    };
}

export function AccountRepresentationToJSON(json: any): AccountRepresentation {
    return AccountRepresentationToJSONTyped(json, false);
}

export function AccountRepresentationToJSONTyped(value?: AccountRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'number': value['number'],
        'subnumber': value['subnumber'],
        'name': value['name'],
        'planType': value['planType'],
        'dataProviderKey': value['dataProviderKey'],
    };
}

